import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
// import './styles/color-override.css'; // DÉSACTIVÉ - forçait tout en blanc avec !important
// Les styles LiveKit sont chargés via index.html pour assurer leur inclusion en production

// Create root element with type assertion for strict mode
const rootElement = document.getElementById('root') as HTMLElement;

// Create root and render app
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ═══ V0.3 PWA — register service worker ═══
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => console.log('[PWA] SW registered, scope:', reg.scope))
      .catch((err) => console.error('[PWA] SW register failed:', err));
  });
}
